<div>
  <mat-card appearance="outlined" class="main-info">
    <mat-card-content noDataTableMessage [dataSource]="notifications">
      @if (notifications?.length) {

      <div *ngFor="let notification of notifications" class="notification">
        <span class="notification__date">
          @if (!isLocalDate) {
          {{ notification?.actualArrivalTime | locale }}
          } @else { @if (displayLocalAndProfileTime) {

          <ui-date-with-profile-and-local-timezone
            [timestamp]="getDateWithTimezones(notification)?.timestamp"
            [localTimezoneData]="getDateWithTimezones(notification)?.localTimezoneData"
            [profileTimezoneData]="getDateWithTimezones(notification)?.profileTimezoneData"
            class="tw-overflow-hidden tw-text-ellipsis"
          ></ui-date-with-profile-and-local-timezone>
          } @else {
          <ui-date-with-timezone
            [localDate]="getLocalDate(notification)"
            [isAligningApplicable]="true"
          ></ui-date-with-timezone>
          } }
        </span>
        <span class="notification__description" cropText>
          {{ notification?.reason }}
        </span>

        <span class="notification__description" cropText>
          {{ 'common.field.source' | translate }}:
          {{ notification?.statusOrigin ? StatusHistoryOriginDisplayMap[notification?.statusOrigin] : '' }}
        </span>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
